"use client"

import { useState } from "react"
import "./QAFaq.css"

const faqData = [
  {
    question: "Why should my business consider Quality Assurance?",
    answer:
      "Your business should consider implementing Quality Assurance (QA) practices at various stages and under different circumstances. Here are some scenarios and stages when integrating QA into your business processes becomes cruciat • Product Development:When initiating a new product or service development project, incorporating QA from the outset ensures that quality considerations are integral to the entire development lifecycle. This proactive approach helps prevent defects and ensures a high-quality end product • Software Development:If your business involves software development, QA is essential to ensure the reliability and functionality of your applications. Implementing QA processes early in the development cycle helps catch and address issues before they reach the production environment • Continuous Integration/Continuous Deployment (CI/CD):As your business adopts CI/CD practices to achieve faster and more frequent releases, integrating QA into the CI/CD pipeline becomes critical. Automated testing during CI/CD helps maintain product quality while enabling swift and reliable releaset • Customer Satisfaction Concerns:If your business has received customer complaints related to product quality, functionality, or reliability, it's a clear signal to consider implementing QA practices. QA helps identify and address issues before they reach customers, improving overall satisfactiot • Compliance and Regulatory Requirements:In industries with strict compliance and regulatory standards, such as healthcare, finance, or aviation, incorporating QA is not just advisable but often mandatory. QA ensures that products and services meet industry-specific standards and regulationt • Business Growth or Scaling:When your business experiences growth or plans to scale its operations, QA becomes essential to maintain consistency and reliability across a larger scope. It helps ensure that quality is not compromised as the business expandt • Cost Reduction:Implementing QA practices can contribute to cost reduction in the long run by preventing the need for extensive post-release bug fixes and customer support. Detecting and fixing issues earlier in the development process is more cost-effective than addressing them after product releast • Reputation Management:If your business heavily relies on its reputation and brand image, maintaining high-quality products and services is crucial. QA helps protect and enhance your brand by delivering reliable and consistent experiences to customert • Project Complexity:When undertaking complex projects that involve intricate systems, integration of various components, or multiple stakeholders, QA becomes indispensable. It ensures that all components work harmoniously and meet the specified requirementt • Continuous Improvement Initiatives:If your business is committed to a culture of continuous improvement, implementing QA practices aligns with this philosophy. QA facilitates the identification of areas for improvement and encourages a systematic approach to refining processes over tt ",
  },
  {
    question: "Why is QA important in software development?",
    answer:
      "Quality Assurance ensures that software meets the specified requirements, is free of critical defects, and functions reliably. By systematically evaluating every aspect of the software, QA significantly reduces the risk of failures and enhances overall customer satisfaction. Ultimately, QA plays a pivotal role in contributing to the success of a project by delivering a high-quality product that meets or exceeds user expectations.",
  },
  {
    question: "What is the difference between manual testing and automation testing?",
    answer:
      "Manual testing involves human testers executing test cases without the use of automation tools. In contrast, automated testing employs software tools to execute pre-scripted tests. Automated testing is particularly efficient for repetitive tasks and regression testing, where multiple test cases need to be repeatedly executed. For example, automated testing tools can be used to simulate user interactions and ensure the software's functionalities remain intact after each code change.",
  },
  {
    question:
      "How do you create effective test cases?",
    answer:
      "Creating effective test cases involves a comprehensive understanding of the requirements. Test cases should cover both positive and negative scenarios, ensuring thorough coverage. It is crucial to design test cases that are independent, clear, and concise. For instance, if testing an e-commerce website, effective test cases would cover scenarios such as successful order placement, handling incorrect payment details, and verifying the accuracy of order confirmations.",
  },
  {
    question: "What is the purpose of a test plan?",
    answer:
      "A test plan serves as a detailed roadmap for the entire testing project. It outlines the strategy, objectives, scope, resources, and schedule. For example, in the context of developing a mobile application, a test plan would specify the devices to be tested, testing methodologies, and the schedule for different testing phases. This document guides the testing team throughout the project, ensuring that testing efforts are aligned with the project goals.",
  },
  {
    question: "How does QA contribute to Agile development?",
    answer:
      "In Agile development, QA is seamlessly integrated throughout the development lifecycle. QA teams collaborate with development and other stakeholders to ensure continuous testing. For instance, in a sprint planning meeting, QA teams actively participate, contributing insights into test requirements. This collaborative approach ensures that quality is maintained with each iteration, aligning development efforts with customer expectations.",
  },
  {
    question:
      "What is Regression Testing and why is it important?",
    answer:
      "Regression testing involves retesting a system after changes to ensure that existing functionalities still work as expected. It is crucial to catch unintended side effects of changes and maintain the overall integrity of the system. For instance, after introducing new features to a software application, regression testing would involve re-executing previously validated test cases to confirm that the existing functionalities remain unaffected.",
  },
 
 
]

const FAQSection = () => {
  const [openItems, setOpenItems] = useState([])

  const toggleItem = (index) => {
    setOpenItems((prev) => (prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]))
  }

  return (
    <div className="faq-container" id="faq">
      <div className="container">
      <div className="faq-wrapper">
        {/* Header */}
        <div className="header-section7160">
          <h1 className="main-title">EVERYTHING YOU NEED TO KNOW ABOUT</h1>
          <h2 className="sub-title">QUALITY ASSURANCE SERVICE</h2>
        </div>

        <div className="content-grid">
          {/* Left Sidebar */}
          <div className="sidebar">
            <div className="sidebar-image">
              <img src="/faq.webp?height=10&width=10" alt="FAQ Illustration" />
            </div>

            <div className="sidebar-content">
              <p className="sidebar-text">
                Browse the Frequently Asked Questions and get your answers. Or better yet - get in touch with our team
                and let's talk!
              </p>
              <button className="quote-button">GET A QUOTE</button>
            </div>
          </div>

          {/* FAQ Section */}
          <div className="faq-section">
            <div className="faq-list">
              {faqData.map((faq, index) => (
                <div key={index} className="faq-item">
                  <div className="faq-question" onClick={() => toggleItem(index)}>
                    <p className="question-text">{faq.question}</p>
                    <div className="chevron-icon">
                      {openItems.includes(index) ? (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <polyline points="18,15 12,9 6,15"></polyline>
                        </svg>
                      ) : (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <polyline points="6,9 12,15 18,9"></polyline>
                        </svg>
                      )}
                    </div>
                  </div>
                  {openItems.includes(index) && (
                    <div className="faq-answer">
                      <p className="answer-text">{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* Scroll Indicator */}
            <div className="scroll-indicator">
              <div className="scroll-dot"></div>
              <div className="scroll-bar"></div>
              <div className="scroll-dot"></div>
            </div>
          </div>
        </div>

        {/* Bottom CTA Section */}
        <div className="cta-section">
          <div className="cta-content">
            <div className="cta-text">
              <h3 className="cta-title">STILL HAVE QUESTIONS?</h3>
              <p className="cta-description">
                Our team of business developers and project managers can help you to clarify any questions you have
                related. Feel free to chat with us anytime.
              </p>
            </div>
            <button className="call-button">BOOK A CALL</button>
          </div>
        </div>
      </div>
      </div>
    </div>
  )
}

export default FAQSection
